import { takeEvery, put, call } from 'redux-saga/effects';
import type { SagaReturnType } from 'redux-saga/effects';
import { PatientPayersActions } from 'src/redux/actions/constant';
import patientService from 'src/services/apiServices/patientService';

const {
  GET_PAYER_DATE_RANGES_REQUEST,
  GET_PAYER_DATE_RANGES_SUCCESS,
  GET_PAYER_DATE_RANGES_FAILURE,
  GET_PAYER_DATE_RANGES_LOADING,
} = PatientPayersActions;

function* getPayerDateRanges(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_PAYER_DATE_RANGES_LOADING });
    const response = yield call(patientService.getPayerDateRanges, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_PAYER_DATE_RANGES_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PAYER_DATE_RANGES_FAILURE, payload: error });
  }
}

function* getPayerDateRangesSaga() {
  yield takeEvery(GET_PAYER_DATE_RANGES_REQUEST, getPayerDateRanges);
}

export default getPayerDateRangesSaga;
